import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { daySales, daySalesReport } from '../../../services/tableOrder.service';
import { getOptions } from '../../../services/payment-method.services';
import { useTranslation } from 'react-i18next';
import { LOADER_TIMEOUT_TIME, PAYMENT_METHOD_TYPES_TRANSACTION, REPORT_TAX_TYPES, SORT_D, SORT_A, CURRENCY_SYMBOL } from '../../../../../utils/Constants';
import { showPrice, getDatesOfMonth, getTotalSalesData, formateDateWithMonthForGraph, writeMyExcel } from '../../../../../utils/commonfunction';
import ReactApexChart from 'react-apexcharts';
import { jsPDF } from 'jspdf'; // Import jsPDF
import { DatePicker } from 'rsuite';
import moment from 'moment';
import RecordNotFound from '../../../shared/recordNotFound';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import html2canvas from 'html2canvas';
import { globalLoader } from "../../../../../utils/commonfunction";
import Sorting from '../../../shared/sorting';
import Skeleton from 'react-loading-skeleton';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PaymentMethodSelect from '../../../shared/PaymentMethodSelect';

export default function SalesReportStatusByDay() {

  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const [saleData, setSaleData] = useState(null);
  const [dailySaleReport, setDailySaleReport] = useState(null);
  const [dailySaleTotalReport, setDailySaleTotalReport] = useState(null);
  const chartRef = useRef(null);
  const [reportDate, setReportDate] = useState(new Date());
  const [paymentMethod, setPaymentMethod] = useState('');
  const [taxType, setTaxType] = useState(REPORT_TAX_TYPES[0].value);
  const componentRef = useRef();
  const [sorting, setSorting] = useState({ column: "date", order: SORT_D });
  const [Type, setType] = useState("day");
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const theme = useSelector((state) => state.theme.mode);

  const today = new Date();

  // Dynamically format the date based on the Type
  const initialSelectedDate =
    Type === "day"
      ? today.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
      : today.toLocaleDateString('en-GB', {
        month: 'short',
        year: 'numeric',
      });
  const lowerButtonRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(initialSelectedDate);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const getTodaySales = (obj) => {
    setLoader(true);
    daySales(obj).then(response => {
      setSaleData(response.data);
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    });
  }


  const getTodaySalesReport = (obj) => {
    setLoader(true);
    daySalesReport(obj).then(response => {
      setDailySaleReport(response?.data?.dailyData || []);
      setDailySaleTotalReport(response?.data?.totalValues || null)
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    });
  }

  useEffect(() => {
    let obj = {
      date: new Date(reportDate),
      paymentMethod: paymentMethod ? paymentMethod : undefined,
      taxType: taxType ? taxType : undefined
    }
    let obj2 = { ...obj }
    if (Object.keys(sorting).length > 0) {
      obj2 = {
        ...obj2,
        'sort': JSON.stringify(sorting)
      }
    }
    getTodaySales(obj);
    getTodaySalesReport(obj2);
  }, [selectedDate, paymentMethod, taxType, sorting]);

  const chartId = 'my-area-chart1';
  const options = useMemo(() => ({
    theme: {
      mode: theme,
    },

    chart: {
      id: chartId,
      height: 280,
      type: "area",
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },

    dataLabels: { enabled: false },

    colors: ["#f28c40", "#008000"],

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        gradientToColors: ["#f28c40"],
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 100, 90],
      },
    },

    xaxis: {
      categories: getDatesOfMonth(reportDate),
    },

    yaxis: {
      labels: {
        formatter: (value) => `${CURRENCY_SYMBOL} ${value?.toFixed(2)}`,
      },
    },

    tooltip: {
      theme: theme,
      y: {
        formatter: (value) => `(${CURRENCY_SYMBOL} ${value?.toFixed(2)})`,
      },
      x: {
        formatter: function (value) {
          const dates = getDatesOfMonth(reportDate);
          const [month, day] = dates[value - 1].split("/");
          const date = new Date(2024, month - 1, day);
          const monthName = date.toLocaleString("en-US", { month: "long" });
          return `${monthName} ${day}`;
        },
      },
      followCursor: true,
      intersect: false,
    },

    legend: {
      position: "top",
    },

    grid: {
      show: true,
      strokeDashArray: 2,
    },

    markers: {
      size: 3,
      strokeColors: ["#f28c40", "#008000"],
      strokeWidth: 1,
    },

    stroke: {
      curve: "smooth",
      width: 2,
    },
  }), [theme, reportDate, chartId]);

  const series = [
    {
      name: t('restaurant.report.totalProfit'),
      data: getTotalSalesData(reportDate, saleData, 'profit')
    },
    {
      name: t('restaurant.report.nav_link_sales'),
      data: getTotalSalesData(reportDate, saleData)
    }
  ];


  const handleExportToExcel = () => {
    // Prepare the data for export
    const headers = [
      t('restaurant.report.graph_byDay.date'),
      t('restaurant.report.graph_byDay.totalTransactions'),
      t('restaurant.report.graph_byDay.totalSales'),
      t('restaurant.report.graph_byDay.totalCostPrice'),
      t('restaurant.report.graph_byDay.totalProfit'),
      t('restaurant.report.graph_byDay.profitRate'), // Will show percentage
      t('restaurant.report.graph_byDay.totalCash'),
      t('restaurant.report.graph_byDay.totalCredit')

    ];

    const rows = dailySaleReport.map((item) => [
      formateDateWithMonthForGraph(item?.date),
      item?.totalTransactions,
      `${CURRENCY_SYMBOL}${showPrice(item?.totalSales)}`,
      `${CURRENCY_SYMBOL}${showPrice(item?.totalCostPrice)}`,
      `${CURRENCY_SYMBOL}${showPrice(item?.totalProfit)}`,
      item.profitRate ? `${item.profitRate.toFixed(2)}%` : '0%',
      `${CURRENCY_SYMBOL}${showPrice(item?.totalCash)}`,
      `${CURRENCY_SYMBOL}${showPrice(item?.totalCredit)}`

    ]);

    // Add total row at the end
    if (dailySaleTotalReport) {
      rows.push([
        t('restaurant.report.graph_byDay.total_label'),
        dailySaleTotalReport?.totalTransactions,
        `${CURRENCY_SYMBOL}${showPrice(dailySaleTotalReport?.totalSales)}`,
        `${CURRENCY_SYMBOL}${showPrice(dailySaleTotalReport?.totalCostPrice)}`,
        `${CURRENCY_SYMBOL}${showPrice(dailySaleTotalReport?.totalProfit)}`,
        dailySaleTotalReport.profitRate
          ? `${dailySaleTotalReport.profitRate.toFixed(2)}%`
          : '0%',
        `${CURRENCY_SYMBOL}${showPrice(dailySaleTotalReport?.totalCash)}`,
        `${CURRENCY_SYMBOL}${showPrice(dailySaleTotalReport?.totalCredit)}`
      ]);
    }

    writeMyExcel([headers, ...rows], "daily_sale_report.xlsx");
  };






  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (sorting.column === column && sorting.order === SORT_A) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  }



  const handleUpperButtonClick = () => {
    if (lowerButtonRef.current) {
      if (isDatePickerOpen) {
        // Close the DatePicker
        lowerButtonRef.current.close(); // Close the DatePicker programmatically
      } else {
        // Open the DatePicker
        lowerButtonRef.current.open(); // Open the DatePicker programmatically
      }
      setIsDatePickerOpen(!isDatePickerOpen); // Toggle the open/close state
    }
  };


  const handleDateChange = (value) => {
    setReportDate(value);
    const formattedDate = value.toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric',
    });
    setSelectedDate(formattedDate); // Update the displayed value
    setIsDatePickerOpen(false); // Close the DatePicker after selection
  };

  const handleToggle = (open) => {
    setIsDatePickerOpen(open);
  };




  // Recalculate the selected date whenever Type or reportDate changes
  useEffect(() => {
    const formattedDate = reportDate.toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric',
    });
    setSelectedDate(formattedDate);
  }, [Type, reportDate]);

  const handleDatePickerClose = () => {
    setIsDatePickerOpen(false); // Close the DatePicker and change the icon state
  };


  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="d-flex tabs-with-etc justify-content-between align-items-center mb-4">
          <ul className="nav nav-pills gap-3">
            <li className="nav-item">
              <Link className="nav-link active" to={"/restaurant/sales"}>
                {t("restaurant.report.byDay")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/restaurant/sales/sales-report-status-month"}>
                {t("restaurant.report.byMonth")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/restaurant/sales/sales-report-status-week"}>
                {t("restaurant.report.byDayOfWeek")}
              </Link>
            </li>
          </ul>
          <div className="tabls-dowpdown">
            <PaymentMethodSelect name="payment_method_type" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}/>
          </div>
        </div>
        <div className="card">
          <div className="card-header border-0">
            <div className="d-flex justify-content-between align-items-center">
              {/* <DatePicker oneTap={true} classPrefix="restaurant" placeholder={t("placeholder_date1")} placement="autoVertical"
                shouldDisableDate={(currentDate) => currentDate && currentDate > moment().endOf('day')} format="MMMM yyyy" cleanable={false} editable={false} name="reservation_date" onChange={(e) => { setReportDate(e) }} value={reportDate} /> */}

              <div style={{ position: "relative", display: "inline-block" }}>
                {/* Upper Button */}
                <button className="btn btn-date" onClick={handleUpperButtonClick}>
                  <i className="ti ti-calendar" style={{ color: "#757575" }}></i> <span style={{ color: "#757575" }}>{selectedDate}</span> <i className={`ti ${isDatePickerOpen ? "ti-chevron-up" : "ti-chevron-down"}`} style={{ color: "#757575" }}></i>
                </button>

                {/* Hidden DatePicker */}
                <div
                  style={{
                    visibility: "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}>
                  <DatePicker
                    ref={lowerButtonRef}
                    oneTap={true}
                    classPrefix="restaurant"
                    placement="bottomStart" // Opens directly beneath the button
                    container={() => document.body} // Prevents clipping by parent containers
                    format="MMMM yyyy"
                    cleanable={false}
                    editable={false}
                    value={reportDate}
                    onChange={handleDateChange}
                    onToggle={handleToggle} // Handle open/close state
                    shouldDisableDate={(currentDate) => currentDate && currentDate > moment().endOf("day")}
                    onClose={handleDatePickerClose}
                  />
                </div>
              </div>

              {/* <button className='btn btn-date'><i className='ti ti-calendar'></i> 14 May 2024 <i className='ti ti-chevron-down'></i></button> */}
              <div className="card-head-group d-flex align-items-center gap-2">
                <select className="form-control cp" name="payment_method_type" value={taxType} onChange={(e) => setTaxType(e.target.value)}>
                  {REPORT_TAX_TYPES.map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {t(item.label)}
                      </option>
                    );
                  })}
                </select>

                <button className="btn btn-black w-100" onClick={handleExportToExcel} disabled={!dailySaleReport || dailySaleReport.length === 0}>
                  <i className="ti ti-download"></i> {t("restaurant.report.label_download")}
                </button>

               
              </div>
            </div>
          </div>
          <div className="card-body position-relative">
            {isDatePickerOpen && <div className="chart-overlay"></div>}
            <div className="chart-container" style={{ position: "relative" }}>
              <ReactApexChart ref={chartRef} options={options} series={series} type="area" height={350} className="dayReport" />
            </div>
          </div>
        </div>
        {loader ? (
          <div className="w-100">
            <Skeleton className="mb-2" height={50} count={5} />
          </div>
        ) : (
          <div className="card mt-4">
            <div className="card-body">
              {dailySaleReport && dailySaleReport.length ? (
                <div className="table-responsive" ref={componentRef}>
                  <table className="table table-printable">
                    <thead>
                      <tr>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="date" columnName={t("restaurant.report.graph_byDay.date")} defaultSorting={defaultSorting} />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalTransactions" columnName={t("restaurant.report.graph_byDay.totalTransactions")} defaultSorting={defaultSorting} breakName="true" />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalSales" columnName={t("restaurant.report.graph_byDay.totalSales")} defaultSorting={defaultSorting} breakName="true" />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalCostPrice" columnName={t("restaurant.report.graph_byDay.totalCostPrice")} defaultSorting={defaultSorting} />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalProfit" columnName={t("restaurant.report.graph_byDay.totalProfit")} defaultSorting={defaultSorting} />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="profitRate" columnName={t("restaurant.report.graph_byDay.profitRate")} defaultSorting={defaultSorting} />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalCash" columnName={t("restaurant.report.graph_byDay.totalCash")} defaultSorting={defaultSorting} />
                        </th>
                        <th>
                          <Sorting sort={sorting} handleSort={handleSort} column="totalCredit" columnName={t("restaurant.report.graph_byDay.totalCredit")} defaultSorting={defaultSorting} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dailySaleReport && dailySaleReport.length
                        ? dailySaleReport.map((item, index) => {
                          return (
                            <tr key={index}>
                              {/* <td>5/1 (Wed)</td> */}
                              <td className="table-date">{formateDateWithMonthForGraph(item?.date)}</td>
                              <td>
                                <span className="text-nowrap">{item?.totalTransactions}</span>
                              </td>
                              <td>
                                <span className="text-nowrap">
                                  {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(item?.totalSales)}
                                </span>
                              </td>
                              <td>
                                <span className="text-nowrap">
                                  {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(item?.totalCostPrice)}
                                </span>
                              </td>
                              <td>
                                <span className="text-nowrap">
                                  {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(item?.totalProfit)}
                                </span>
                              </td>
                              <td>
                                <span className="text-nowrap">{item.profitRate ? item.profitRate.toFixed(2) : 0}</span>%
                              </td>
                              <td>
                                <span className="text-nowrap">
                                  {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(item?.totalCash)}
                                </span>
                              </td>
                              <td>
                                <span className="text-nowrap">
                                  {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(item?.totalCredit)}
                                </span>
                              </td>
                            </tr>
                          );
                        })
                        : ""}
                      {dailySaleTotalReport && (
                        <tr className="total-tr" id="totalSale">
                          <td>{t("restaurant.report.graph_byDay.total_label")}</td>
                          <td>
                            <span className="text-nowrap">{dailySaleTotalReport?.totalTransactions}</span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(dailySaleTotalReport?.totalSales)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(dailySaleTotalReport?.totalCostPrice)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(dailySaleTotalReport?.totalProfit)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">{dailySaleTotalReport.profitRate ? dailySaleTotalReport.profitRate.toFixed(2) : 0}</span>%
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(dailySaleTotalReport?.totalCash)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byDay.currency_symbol")} {showPrice(dailySaleTotalReport?.totalCredit)}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <RecordNotFound heading="restaurant.report.lbl_record_not_found" />
              )}
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
